import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#E8B9CF",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#B41660",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles("dark", {
      borderColor: theme.palette.grey[800],
    }),
  },
  [`& .customConnectorLine`]: {
    borderColor: "#B41660",
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles("dark", {
      borderColor: theme.palette.grey[800],
    }),
  },
  [`&.${stepConnectorClasses.disabled}`]: {
    [`& .customConnectorLine`]: {
      borderColor: "#eaeaf0",
      borderTopWidth: 3,
      borderRadius: 1,
      ...theme.applyStyles("dark", {
        borderColor: theme.palette.grey[800],
      }),
    },
  },
}));

const QontoStepIconRoot = styled("div")(({ theme }) => ({
  color: "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  "& .QontoStepIcon-completedIcon": {
    color: "#49AF41",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  ...theme.applyStyles("dark", {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: "#FF9A3A",
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const {
    active,
    completed,
    className,
    isMainStageCompleted,
    stepIndex,
    activeStep,
  } = props;
  let iconContent;
  if (stepIndex < activeStep) {
    iconContent = isMainStageCompleted ? (
      <Check className="QontoStepIcon-completedIcon" />
    ) : (
      <div
        className="QontoStepIcon-circle"
        style={{ backgroundColor: "#FF9A3A" }}
      />
    );
  } else if (stepIndex == activeStep) {
    iconContent = isMainStageCompleted ? (
      <Check className="QontoStepIcon-completedIcon" />
    ) : (
      <div
        className="QontoStepIcon-circle"
        style={{ backgroundColor: "#FF9A3A" }}
      />
    );
  } else {
    iconContent = (
      <div
        className="QontoStepIcon-circle"
        style={{ backgroundColor: "#eaeaf0" }}
      />
    );
  }

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {iconContent}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  isMainStageCompleted: PropTypes.bool,
  stepIndex: PropTypes.number,
  activeStep: PropTypes.number,
};

export default function StatusStepper({ steps, activeStepnew }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Stack sx={{ width: "100%", overflow: "auto" }} spacing={4}>
      <Stepper
        variant="scrollable"
        // scrollButtons={isMobile ? "auto" : "off"}
        // allowScrollButtonsMobile
        alternativeLabel
        activeStep={activeStepnew}
        connector={
          <QontoConnector
            classes={{
              line: "customConnectorLine",
            }}
          />
        }
      >
        {steps &&
          steps?.map((step, index) => (
            <Step key={index} completed={step.isMainStageCompleted}>
              <StepLabel
                StepIconComponent={(props) => (
                  <QontoStepIcon
                    {...props}
                    stepIndex={index}
                    activeStep={activeStepnew}
                    isMainStageCompleted={step.isMainStageCompleted}
                  />
                )}
              >
                {step.isTitle ? (
                  <Box sx={{ fontWeight: 700, fontSize: "16px" }}>
                    {step.title}
                  </Box>
                ) : (
                  step.title
                )}
              </StepLabel>
            </Step>
          ))}
      </Stepper>
    </Stack>
  );
}
